import LessonFork from "../../../../src/components/lesson-fork.js";
import DeployingFromVersionControl from "../../../../src/courses/partials/responsible-development/deploying-from-version-control/index.mdx";
import * as React from 'react';
export default {
  LessonFork,
  DeployingFromVersionControl,
  React
};